import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { registerSW } from "virtual:pwa-register";
import { App } from "./App.js";
import { sperreUeberscrollen } from "./lib/ueberscrollSperre.js";
import { wendeSymbolAn } from "./lib/appsymbole.js";
import "./index.css";

// autoUpdate (vite.config.ts): eine neue Version ersetzt den Service
// Worker im Hintergrund selbst, kein Update-Dialog noetig. Fehlt der
// Browser-Support (oder laeuft die Seite nicht ueber HTTPS), tut der
// Aufruf einfach nichts - kein Fehlerfall, den man abfangen muesste.
registerSW({ immediate: true });

// Einmal fuer die ganze App, siehe lib/ueberscrollSperre.ts.
sperreUeberscrollen();

// Vor dem Mount: der Browser liest Manifest und apple-touch-icon beim
// Installieren aus dem Dokument, und "Zum Home-Bildschirm" kann jederzeit
// kommen. Steht die Umhaengung erst in einer Komponente, ist sie beim
// ersten Bild noch nicht passiert.
wendeSymbolAn();

// Die Daten dieser App aendern sich selten und fast nur durch eigenes
// Zutun. Erst ab Phase 6 schiebt SSE fremde Aenderungen herein, und dann
// wird gezielt invalidiert statt im Hintergrund gepollt.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const wurzel = document.getElementById("root");
if (!wurzel) throw new Error("#root fehlt in index.html");

createRoot(wurzel).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
